import React, { useEffect, useState } from "react"
import roundSelectorStyles from './ZerosRow.module.scss';
import ZerosModalDialog from "./ZerosModalDialog";

export default function ZerosRow({torneo}: any) {
  useEffect(()=>{},[torneo]);

  const getLossest = (torneo) => {
    let maxLosses = 0;
    torneo.doublets.map((item) => {
      if (item.losses > maxLosses) {
        maxLosses = item.losses
      }
    })
    return maxLosses;
  }

  const getUsersWithThisCero = (torneo, i) => {
    let total = 0;
    torneo.doublets.map((item) => {
      if (item.losses === i) {
        total++
      }
    })
    return total;
  }

  const getDoubletsWithThisCero = (torneo, i) => {
    let doublets = [];
    torneo.doublets.map((item) => {
      if (item.losses === i) {
        doublets.push(item);
      }
    })
    return doublets;
  }

  const renderListCeros = (torneo) => {
    let nums = [];
    let lossest = getLossest(torneo);
    for (let i = 0; i <= (torneo.championType === "Liga" ? lossest : torneo.numZeros); i++) {
      getUsersWithThisCero(torneo, i) !== 0 ?
      nums.push(
        <RoundNumber
          cero={i}
          numUsersWithThisCero={getUsersWithThisCero(torneo, i)}
          doublets={getDoubletsWithThisCero(torneo, i)}
        />
      ) : <></>
    }
    return nums
  }


  const RoundNumber = ({ cero, numUsersWithThisCero, doublets }) => {
    
    const [showZerosModalList, setShowZerosModalList] = useState({show: false, cero: -1});

    useEffect(()=>{},[showZerosModalList]);

    const displayPlayersZeros = (event, cero) => {
      setShowZerosModalList({show: true, cero: cero});
      event.stopPropagation();
    }

    const closeAction = () => {
      setShowZerosModalList({show: false, cero: -1});
    }

    return (<div aria-label='First Group' className={roundSelectorStyles.zerosRow + ' ' + roundSelectorStyles.zerosRowFont}>
              <div style={{display: "flex"}}>
                <b className={roundSelectorStyles.notificationcircle}
                  style={{
                    background:
                      cero === 0 ? "rgba(75, 175, 79, 1)" :
                      cero % 3 === 0 ? "rgba(255, 0, 0, 0." + (99 - (cero * 6 )) + ")" : 
                      cero % 2 === 0 ? "rgba(255, 153, 0,  0." + (99 - (cero * 6 )) + ")" : 
                      cero % 1 === 0 ? "rgba(0, 100, 0,  0." + (99 - (cero * 6 )) + ")":
                      "rgba(255, 0, 0, 1)", 
                    color: 'white',
                    cursor: 'cursor'
                  }} 
                  onClick={(event)=>{displayPlayersZeros(event, cero)}}>{cero}</b>
                {/* <i className={roundSelectorStyles.notificationcircle} 
                  style={{background: "transparent"}}>{numUsersWithThisCero}</i> */}
                <i className={roundSelectorStyles.notificationcircle} 
                  onClick={(event)=>{displayPlayersZeros(event, cero)}}
                  style={{background: "rgba(0, 128, 0, 0.1)"}}>{numUsersWithThisCero}</i>
              </div>
              {(doublets && showZerosModalList && showZerosModalList.show && showZerosModalList.cero === cero) &&
                      <ZerosModalDialog
                        show={showZerosModalList.show}
                        setShow={setShowZerosModalList}
                        cero={cero}
                        doublets={doublets}
                        closeAction={closeAction}>
                      </ZerosModalDialog>}
            </div>
          )
  }

  return (
    torneo && torneo.roundResults && <div style={{display: "flex", justifyContent: "center"}}>
        <div style={{ marginBottom: ".5em", display: "inline-flex" }}>
          <b className={roundSelectorStyles.zerosRowFont}>Ceros:  </b>{renderListCeros(torneo)}
        </div>
      </div>
    )
  }


